import { Div, Label, P, Span } from '@kizi/core-components';
import { IconV2 as Icon } from '@kizi/shared-components';
import React from 'react';

export interface CheckboxTileLabelProps {
  label: string;
  additionalInfo?: string;
  subLabel?: string;
  icon: string;
}

export const CheckboxTileLabel: React.FC<CheckboxTileLabelProps> = ({
  label,
  additionalInfo,
  subLabel,
  icon,
}): JSX.Element => {
  return (
    <Label variant="">
      <Div display="flex" flexDirection="column" className="tile-content">
        <Div display="flex" alignItems="center">
          <Icon name={icon} width={20} height={20} marginRight={2} />
          <P variant="bodyImportant" marginRight={1}>
            {label}
          </P>
          {<Span variant="footnoteRegular">{additionalInfo}</Span>}
        </Div>
        {subLabel && <Span>{subLabel}</Span>}
      </Div>
    </Label>
  );
};
